import cn from "classnames";
import { ErrorBoundary } from "shared/ui/ErrorBoundary";
import styles from "./PanelWrapper.module.scss";

type PanelWrapperProps = {
  className?: string;
  isPanelLoading?: boolean;
};

export const PanelWrapper: RFC<PanelWrapperProps> = ({ children, isPanelLoading, className }) => {
  return (
    <div className={cn(styles.panel, className, { [styles.loader]: isPanelLoading })}>
      <ErrorBoundary>{children}</ErrorBoundary>
    </div>
  );
};
